import { gql } from '@apollo/client/core';
import { client } from '@/shared/apollo-api/business/client';
import type { GraphQLFormattedError } from 'graphql';
import { facetFragment } from '@/shared/apollo-api/api/fragments/facet';
import {
  category,
  currentCategory,
  fastCategory,
} from '@/shared/apollo-api/api/fragments/category';
import { skuGroupCardFragment } from '@/shared/apollo-api/api/fragments/catalog-cards/sku-group-card';
import { defaultCardFragment } from '@/shared/apollo-api/api/fragments/catalog-cards/common-data';
import type { MakeSearchQueryInput, MakeSearchResult } from '@/shared/apollo-api/__generated__/types';

export const makeSearch = async (
  queryInput: MakeSearchQueryInput,
  cityId: number
): Promise<{
  makeSearchResponse: MakeSearchResult;
  errors: ReadonlyArray<GraphQLFormattedError>;
}> => {
  const {
    data: { makeSearch },
    errors,
  } = await client.query({
    query: gql`
      query getMakeSearch($queryInput: MakeSearchQueryInput!, $cityId: Int!) {
        makeSearch(query: $queryInput) {
          id
          queryId
          queryText
          category {
            ...CategoryShortFragment
          }
          categoryTree {
            category {
              ...CategoryFragment
            }
            total
          }
          items {
            adMarker {
              orgInn
              marker
              orgName
            }
            catalogCard {
              __typename
              cardNearestDeliveryInfo(cityId: $cityId) {
                nearestDelivery
              }
              ...SkuGroupCardFragment
              ... on ProductCard {
                ...DefaultCardFragment
              }
            }
            bidId
          }
          facets {
            ...FacetFragment
          }
          total
          mayHaveAdultContent
          categoryFullMatch
          offerCategory {
            title
            id
          }
          correctedQueryText
          categoryWasPredicted
          fastCategories {
            category {
              ...FastCategoryFragment
            }
            total
          }
          token
        }
      }
      ${facetFragment}
      ${category}
      ${currentCategory}
      ${fastCategory}
      ${skuGroupCardFragment}
      ${defaultCardFragment}
    `,
    variables: {
      queryInput,
      cityId,
    },
    errorPolicy: 'all',
  });

  return { makeSearchResponse: makeSearch, errors: errors || [] };
};
